export default "__VITE_ASSET__TgJcTwyW__"